import * as React from 'react';
import { SearchForm } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';
import theme from '../../theme/theme';
import siteSearchFormTheme from '../../theme/searchFormTheme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import { OverrideComponent, RenderersProvider } from '@websky/core/src/renderProps';
import engineRenderers from '../../renderProps';

const SearchFormComponent: React.FC = () => {
	return (
		<ThemeProvider value={theme}>
			<RenderersProvider value={engineRenderers}>
				<Head includeSlickStyles={false} />

				<ThemeProvider value={siteSearchFormTheme}>
					<OverrideComponent<React.ComponentProps<typeof SearchForm>>
						componentProps={{}}
						component={{ SearchForm: SearchForm }}
					/>
				</ThemeProvider>
			</RenderersProvider>
		</ThemeProvider>
	);
};

export default SearchFormComponent;
